import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CargaMasivaComponent } from './carga-masiva/carga-masiva.component';
import { CargaMasivaRouting } from './carga-masiva.routing';
import { SharedModule } from 'app/shared/shared.module';
import { FuseCardModule } from '@fuse/components/card/card.module';
import { NuevaCargaMasivaComponent } from 'app/utilerias/nueva-carga-masiva/nueva-carga-masiva.component';

@NgModule({
  declarations: [
    CargaMasivaComponent,
    NuevaCargaMasivaComponent
  ],
  imports: [
    CommonModule,
    CargaMasivaRouting,
    SharedModule,
    FuseCardModule
  ]
})
export class CargaMasivaModule { }
